import { configureStore } from "@reduxjs/toolkit";
import reducerCombined from "./reducers";

export const store = configureStore({
  reducer: reducerCombined,
});
